import React, { useState } from "react";
import Cookies from "js-cookie";
import Superagent from "superagent";
import styled from "styled-components";
import { Icon, Loader, Popup, Radio } from "semantic-ui-react";
import { t, tp } from "../../../constant/translations";
import { RoleRequired } from "../../auth/role-required";
import { permissions } from "../../../constant/permissions";

const GearButton = styled.button`
  position: absolute;
  bottom: 18px;
  right: 22px;
  z-index: 6;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  backdrop-filter: blur(6px);
  transition: background 0.15s;
  padding: 0;
  line-height: 1;

  &:hover {
    background: rgba(0, 0, 0, 0.6);
  }

  i.icon {
    margin: 0 !important;
    height: 1em;
    width: 1em;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

const Panel = styled.div`
  width: 280px;
  padding: 4px;
  font-size: 13px;
  color: #1f242c;
`;

const Section = styled.div`
  padding: 10px 6px;
  border-bottom: 1px solid #ececef;

  &:last-child {
    border-bottom: none;
  }
`;

const SectionLabel = styled.div`
  font-size: 10px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #aab0b8;
  font-weight: 700;
  margin-bottom: 8px;
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
`;

const Slot = styled.label`
  position: relative;
  aspect-ratio: 1;
  border: ${({ $primary }) =>
    $primary ? "2px solid #1a7fc1" : "1px dashed #cfd2d8"};
  border-radius: 4px;
  background: ${({ $src }) => ($src ? `center/cover url(${$src})` : "#fafafb")};
  cursor: ${({ $busy }) => ($busy ? "wait" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aab0b8;
  font-size: 16px;
  opacity: ${({ $busy }) => ($busy ? 0.6 : 1)};

  input {
    display: none;
  }

  &:hover {
    border-color: #1a7fc1;
    color: #1a7fc1;
  }
`;

const StarBtn = styled.button`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${({ $active }) => ($active ? "#1a7fc1" : "rgba(0, 0, 0, 0.5)")};
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ $active }) =>
      $active ? "#1569a3" : "rgba(0, 0, 0, 0.75)"};
  }

  i.icon {
    margin: 0 !important;
    font-size: 10px;
    line-height: 1;
  }
`;

const ClearBtn = styled.button`
  position: absolute;
  top: 2px;
  right: 2px;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 10px;
  line-height: 1;
  cursor: pointer;
  display: ${({ $visible }) => ($visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
`;

const ModeRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

const ModeChip = styled.button`
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid ${({ $active }) => ($active ? "#1a7fc1" : "#d4d8de")};
  background: ${({ $active }) => ($active ? "#eef5fb" : "#fff")};
  color: ${({ $active }) => ($active ? "#1a7fc1" : "#4a525e")};
  font-size: 12px;
  cursor: pointer;
  font-weight: 500;
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LogoPreview = styled.label`
  width: 56px;
  height: 40px;
  border: 1px dashed #cfd2d8;
  border-radius: 4px;
  background: ${({ $src }) =>
    $src ? `center/contain no-repeat url(${$src}) #fafafb` : "#fafafb"};
  cursor: ${({ $busy }) => ($busy ? "wait" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aab0b8;
  opacity: ${({ $busy }) => ($busy ? 0.6 : 1)};

  input {
    display: none;
  }
`;

const LogoMeta = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SliderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  input[type="range"] {
    flex: 0 1 140px;
    height: 4px;
    -webkit-appearance: none;
    appearance: none;
    background: #e3e4e8;
    border-radius: 2px;
    outline: none;
    padding: 0;
    margin: 0;
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #1a7fc1;
    border: none;
    cursor: pointer;
  }

  input[type="range"]::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #1a7fc1;
    border: none;
    cursor: pointer;
  }
`;

const InvertToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #4a525e;
`;

const SmallText = styled.span`
  font-size: 11px;
  color: #888e98;
  font-variant-numeric: tabular-nums;
`;

async function uploadUserFiles(files) {
  const reqs = files.map((file) =>
    Superagent.post("/api/user-file/")
      .set("X-CSRFToken", Cookies.get("csrftoken"))
      .attach("content", file)
  );
  const results = await Promise.all(reqs);
  return results.map((r) => ({
    uuid: r.body.uuid,
    url: r.body.content,
    optimized_url: r.body.optimized_url || null,
  }));
}

export const HeroControls = ({
  images,
  setImages,
  primary,
  setPrimary,
  logo,
  setLogo,
  logoMode,
  setLogoMode,
  logoScale,
  setLogoScale,
  needsInvert,
  setNeedsInvert,
}) => {
  const [uploadingImages, setUploadingImages] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);

  const handleImagePick = async (files) => {
    if (!files || files.length === 0) return;
    setUploadingImages(true);
    try {
      const uploaded = await uploadUserFiles(Array.from(files));
      setImages([...images, ...uploaded]);
    } finally {
      setUploadingImages(false);
    }
  };

  const handleLogoPick = async (file) => {
    if (!file) return;
    setUploadingLogo(true);
    try {
      const [uploaded] = await uploadUserFiles([file]);
      setLogo(uploaded);
    } finally {
      setUploadingLogo(false);
    }
  };

  const removeImage = (idx) => {
    const removed = images[idx];
    setImages(images.filter((_, i) => i !== idx));
    if (removed && primary === removed.uuid) {
      setPrimary(null);
    }
  };

  return (
    <RoleRequired permission={permissions.blockEdit}>
      <Popup
        on="click"
        position="top right"
        trigger={
          <GearButton aria-label={t("block.hero.settings")} type="button">
            <Icon name="setting" />
          </GearButton>
        }
      >
        <Panel>
          <Section>
            <SectionLabel>{t("block.hero.building_photos")}</SectionLabel>
            <ImageGrid>
              {images.map((img, idx) => {
                const isPrimary = primary === img.uuid;
                return (
                  <Slot
                    key={img.uuid || idx}
                    $src={img.url}
                    $primary={isPrimary}
                    title={tp("block.hero.photo_n", { n: idx + 1 })}
                  >
                    <StarBtn
                      type="button"
                      $active={isPrimary}
                      onClick={(e) => {
                        e.preventDefault();
                        setPrimary(isPrimary ? null : img.uuid);
                      }}
                      aria-label={t("block.hero.make_primary")}
                    >
                      <Icon name={isPrimary ? "star" : "star outline"} />
                    </StarBtn>
                    <ClearBtn
                      type="button"
                      $visible
                      onClick={(e) => {
                        e.preventDefault();
                        removeImage(idx);
                      }}
                      aria-label={t("block.hero.delete")}
                    >
                      ×
                    </ClearBtn>
                  </Slot>
                );
              })}
              <Slot title={t("block.hero.add_photo")} $busy={uploadingImages}>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  disabled={uploadingImages}
                  onChange={(e) => {
                    handleImagePick(e.target.files);
                    e.target.value = "";
                  }}
                />
                {uploadingImages ? <Loader active inline size="tiny" /> : "+"}
              </Slot>
            </ImageGrid>
          </Section>

          <Section>
            <SectionLabel>{t("block.hero.logo")}</SectionLabel>
            <LogoRow>
              <LogoPreview $src={logo && logo.url} $busy={uploadingLogo}>
                <input
                  type="file"
                  accept="image/*"
                  disabled={uploadingLogo}
                  onChange={(e) => {
                    handleLogoPick(e.target.files[0]);
                    e.target.value = "";
                  }}
                />
                {uploadingLogo ? (
                  <Loader active inline size="tiny" />
                ) : (
                  !logo && <Icon name="image outline" />
                )}
              </LogoPreview>
              <LogoMeta>
                {logo && (
                  <ModeChip
                    type="button"
                    onClick={() => setLogo(null)}
                    style={{ alignSelf: "flex-start" }}
                  >
                    {t("block.hero.remove")}
                  </ModeChip>
                )}
                <InvertToggle>
                  <Radio
                    toggle
                    checked={needsInvert}
                    onChange={() => setNeedsInvert(!needsInvert)}
                  />
                  {t("block.hero.invert_logo")}
                </InvertToggle>
              </LogoMeta>
            </LogoRow>
          </Section>

          <Section>
            <SectionLabel>{t("block.hero.logo_display")}</SectionLabel>
            <ModeRow>
              {[
                { value: "overlay", label: t("block.hero.mode.overlay") },
                { value: "chip", label: t("block.hero.mode.chip") },
                { value: "text", label: t("block.hero.mode.text") },
                { value: "none", label: t("block.hero.mode.none") },
              ].map((opt) => (
                <ModeChip
                  key={opt.value}
                  type="button"
                  $active={logoMode === opt.value}
                  onClick={() => setLogoMode(opt.value)}
                >
                  {opt.label}
                </ModeChip>
              ))}
            </ModeRow>
          </Section>

          <Section>
            <SectionLabel>{t("block.hero.logo_size")}</SectionLabel>
            <SliderRow>
              <input
                type="range"
                min="0.5"
                max="1.8"
                step="0.05"
                value={logoScale}
                onChange={(e) => setLogoScale(parseFloat(e.target.value))}
              />
              <SmallText>{logoScale.toFixed(2)}×</SmallText>
            </SliderRow>
          </Section>
        </Panel>
      </Popup>
    </RoleRequired>
  );
};
